module.exports = __webpack_public_path__ + "img/photo-4.5c024271.jpg";